import { alpha, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Theme } from "@mui/material";
import React, { useState } from "react";
import { EmailTemplateLink } from "../../../../types/EmailTemplate";
import { useGetEmailDataById } from "../../../../services/react-query/email_data/useGetEmailDataById";
import _ from "lodash";
import { listPageTableRowStyling } from "../../../../styles/sxStyling";
import EmailEventsPopover from "./EmailEventsPopover";
import { EmailDatum } from "../../../../types/EmailDatum";
import { modalStyles } from "../../../../styles/modalStyles";
import EmailBodyView from "../common/EmailBodyView";

interface IEmailDataModalProps {
  open: boolean;
  onClose: () => void;
  selectedTemplate: EmailTemplateLink | null;
}

export default function EmailDataModal({ open, onClose, selectedTemplate }: IEmailDataModalProps) {
  if (!selectedTemplate) return null;

  const [selectedDatum, setSelectedDatum] = useState<EmailDatum | null>(null);
  const { data, isLoading, isError } = useGetEmailDataById({ uuid: selectedTemplate?.uuid });

  const selectedColor = { backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity) };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Email Activity</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Box sx={modalStyles.loadingBox}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Box sx={modalStyles.errorBox}>Failed to load email activity.</Box>
        ) : (
          <Box sx={modalStyles.container}>
            <Table sx={{ mb: 4 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Recipient</TableCell>
                  <TableCell>Subject</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Last Event</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  _.map(data, datum => (
                    <TableRow sx={{ ...listPageTableRowStyling, cursor: 'pointer', ...(selectedDatum?.id === datum.id ? selectedColor : {}) }} onClick={() => setSelectedDatum(datum)}>
                      <TableCell>{datum.recipient}</TableCell>
                      <TableCell>{datum.subject}</TableCell>
                      <TableCell>{datum.status}</TableCell>
                      <TableCell><EmailEventsPopover emailEvents={datum.email_events} /></TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>

            <EmailBodyView body={selectedDatum?.content} />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}